import React from "react";

import { Card, Badge } from "reactstrap";
import { Link } from 'react-router-dom';

var Utils = require ('Utils');
var Const = require ('Const');

export const TeacherCard = ( props ) => { 

    let {
        persona,
        showCourse
      } = props;


    return (
        <>
        {persona && 
            <Card className="card-user">
                <div className="image">
                  <img
                    alt="..."
                    src={require("img/student-badge-back.jpg")}
                  />
                </div>
                <div className="author">
                <Link to={"/admin/students/"+persona.persona_id}>
                    <img
                    alt="..."
                    className="avatar border-gray"
                    src={persona.image?persona.image:Const.DEFAULT_IMAGE_PROFILE[(persona.gender?persona.gender:'O')]}
                    />
                    <p className="h5">
                      {Utils.capitalize(persona.last_name + ", " + persona.name)}
                    </p>
                  </Link>
                  { persona.tags && persona.tags.map( tag => {
                     return ( 
                        <Badge style={{ backgroundColor: "#"+ tag.tag_color }}>{tag.tag_label}</Badge>
                     )
                    }) }
                  

                  {showCourse && 
                     <p> {persona.course_name}</p>
                    }
                </div>
                
              </Card>
            }
        </>
    );
  }
 